import { useCallback, useRef } from 'react'
import { useEvent, useIsomorphicLayoutEffect } from 'react-use'
import localFont from 'next/font/local'

const gotham = localFont({
  src: [
    {
      path: './fonts/Gotham-Book.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/Gotham-Medium.woff2',
      weight: '500',
      style: 'normal'
    }
  ]
})

export type ThemeProps = Partial<{
  theme: 'dark' | 'light'
}>

const Theme = ({}: ThemeProps) => {
  const lastViewportWidth = useRef(0)

  const resize = useCallback(() => {
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (lastViewportWidth.current === viewportWidth) return
    lastViewportWidth.current = viewportWidth

    const vh = (viewportHeight * 0.01).toFixed(2)
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [])

  useIsomorphicLayoutEffect(() => resize(), [resize])

  useEvent('resize', resize)

  return (
    <style jsx global>{`
      :root {
        --font-family-base: ${gotham.style.fontFamily};
        --header-height: 9.4rem;

        --font-size: 10px;
      }

      @media (min-width: 768px) {
        :root {
          --header-height: 9.4rem;
        }
      }
    `}</style>
  )
}

export default Theme
